import moment from "moment";

export const getLast2Years = () => {
  const years = [];
  const currentYear = new Date().getFullYear();

  // Generate current year and previous year
  for (let i = 0; i < 2; i++) {
    const year = currentYear - i;

    years.push({
      key: year, // use year as key
      value: `${year}`, // formatted string as value
      year: year,
      fullDate: moment(`${year}-01-01`).format("YYYY-MM-DD"), // first day of year
    });
  }

  return years;
};
